var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"debug",class:{hidden: !_vm.is_open}},[_c('a',{staticStyle:{"display":"inline-block","float":"right"},attrs:{"href":"javascript:void(0)"},on:{"click":function($event){_vm.is_open=!_vm.is_open}}},[_vm._v("●●●")]),(_vm.is_open)?_c('div',{staticClass:"content"},[_vm._t("default")],2):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }